import { makeStyles } from "@material-ui/core/styles";

const useCommonStyles = makeStyles((theme) => ({
  switchButton: {
    marginTop: "24px",
    backgroundColor: "#003a6b",
    color: "#fff !important",
    "&:hover": {
      backgroundColor: "#002849",
      // boxShadow: "0 4px 8px rgba(0, 58, 107, 0.3)",
    },
  },
  root: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    minHeight: "100vh",
    padding: theme.spacing(3, 0),
  },
  rootConatiner: {
    transition: "all 0.3s ease-in-out", // smooth animation
    marginTop: "5rem",
    maxHeight: "20vh",
    marginLeft: (props) => (props.isSidebarOpen ? "16rem" : "4rem"), // dynamic margin
    width: (props) => (props.isSidebarOpen ? "85%" : "96%"), // dynamic width
  },
  mainCard: {
    borderRadius: 20,
    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
    overflow: "hidden",
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%)",
  },
  header: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: theme.spacing(3),
    textAlign: "center",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: 20,
      background: "#ffffff",
      borderRadius: "20px 20px 0 0",
    },
  },
  formSection: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
  },
  saveButton: {
    minWidth: 120,
    borderRadius: 25,
    textTransform: "none",
    fontWeight: 600,
    background: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",
  },
  inputCard: {
    background: "#ffffff",
    borderRadius: 16,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: "1px solid #e3f2fd",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
      transform: "translateY(-2px)",
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      backgroundColor: "#fafbff",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: "#f0f4ff",
        "& fieldset": {
          borderColor: "#667eea",
        },
      },
      "&.Mui-focused": {
        backgroundColor: "#ffffff",
        "& fieldset": {
          borderColor: "#667eea",
          borderWidth: 2,
        },
      },
    },
    "& .MuiInputLabel-outlined": {
      color: "#64748b",
      fontWeight: 500,
    },
  },
  label: {
    color: "#475569",
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  modernTextField: {
    "& .MuiOutlinedInput-root": {
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "16px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      backdropFilter: "blur(10px)",
      "& fieldset": {
        border: "2px solid rgba(102, 126, 234, 0.2)",
        transition: "all 0.3s ease",
      },
      "&:hover": {
        background: "rgba(255, 255, 255, 0.95)",
        transform: "translateY(-1px)",
        boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
        "& fieldset": {
          border: "2px solid rgba(102, 126, 234, 0.4)",
        },
      },
      "&.Mui-focused": {
        background: "rgba(255, 255, 255, 1)",
        transform: "translateY(-2px)",
        boxShadow: "0 12px 30px rgba(102, 126, 234, 0.2)",
        "& fieldset": {
          border: "2px solid #667eea",
        },
      },
    },
  },
  modernAutocomplete: {
    "& .MuiOutlinedInput-root": {
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "16px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      backdropFilter: "blur(10px)",
      "& .MuiAutocomplete-inputRoot": {
        padding: "0 !important",
        margin: "0 !important",
      },
      "MuiFormControl-fullWidth": {
        maxWidth: "10%",
      },
      "& input": {
        padding: "5px 14px !important",
      },
      "& fieldset": {
        border: "2px solid rgba(102, 126, 234, 0.2)",
      },
      "&:hover": {
        background: "rgba(255, 255, 255, 0.95)",
        transform: "translateY(-1px)",
        boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
        "& fieldset": {
          border: "2px solid rgba(102, 126, 234, 0.4)",
        },
      },
      "&.Mui-focused": {
        background: "rgba(255, 255, 255, 1)",
        transform: "translateY(-2px)",
        boxShadow: "0 12px 30px rgba(102, 126, 234, 0.2)",
        "& fieldset": {
          border: "2px solid #667eea",
        },
      },
    },
  },
  switchCard: {
    background: "linear-gradient(135deg, #e8f5e8 0%, #f0fff4 100%)",
    borderRadius: 16,
    padding: theme.spacing(2),
    border: "1px solid #c6f6d5",
    textAlign: "center",
  },
  radioGroup: {
    background: "#ffffff",
    borderRadius: 12,
    padding: theme.spacing(1.5),
    border: "1px solid #e2e8f0",
  },
  designationSection: {
    background: "linear-gradient(135deg, #fff7ed 0%, #fef3c7 100%)",
    borderRadius: 16,
    padding: theme.spacing(3),
    border: "1px solid #fed7aa",
  },
  imageUpload: {
    width: 200,
    height: 220,
    margin: "0 auto",
    position: "relative",
    border: "3px dashed #cbd5e1",
    borderRadius: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    background: "linear-gradient(145deg, #f8fafc 0%, #e2e8f0 100%)",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#667eea",
      background: "linear-gradient(145deg, #f0f4ff 0%, #e0e7ff 100%)",
      transform: "scale(1.02)",
    },
  },
  imageUploadWithFile: {
    border: "3px solid #667eea",
    background: "#ffffff",
  },
  uploadText: {
    color: "#667eea",
    fontWeight: 600,
    fontSize: "16px",
    textAlign: "center",
    cursor: "pointer",
    padding: theme.spacing(2),
    borderRadius: 12,
    background: "rgba(102, 126, 234, 0.1)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.2)",
      transform: "translateY(-1px)",
    },
  },
  clearButton: {
    position: "absolute",
    top: 8,
    right: 8,
    background: "rgba(255, 255, 255, 0.9)",
    "&:hover": {
      background: "#fff",
    },
  },
  sectionDivider: {
    margin: theme.spacing(3, 0),
    background: "linear-gradient(90deg, transparent, #667eea, transparent)",
    height: 2,
  },
  areaAccessCard: {
    background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
    borderRadius: 16,
    padding: theme.spacing(3),
    border: "1px solid #bae6fd",
    marginTop: theme.spacing(3),
  },
  gridSpace: {
    margin: 0,
    width: "100%",
    marginBottom: "1rem",
  },
  gridSpace2: {
    margin: 0,
    width: "100%",
    marginBottom: "1rem",
    padding: "0 20px",
  },

  redButton: {
    backgroundColor: "#29275cff !important",
    color: "#fff !important",
  },

  switchBase: {
    color: "red",
    "&$checked": {
      color: "green",
    },
    "&$checked + $track": {
      backgroundColor: "green",
    },
    "& + $track": {
      backgroundColor: "red",
    },
  },
  checked: {},
  track: {},
}));

export default useCommonStyles;
